import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { ThemeContext } from 'constants/theme';

import styles from './loading-state.less';
import chartLoadingImageSrc from 'images/chart-loader-2x.gif';
import chartLoadingImageSrcDark from 'images/chart-loader-dark-2x.gif';

const LOADING_IMAGE_SRC = {
  light: chartLoadingImageSrc,
  dark: chartLoadingImageSrcDark,
};

/**
 * A reuseable loading state component that renders a loading image/gif,
 * which by default is the filling donut chart, and some text on the right.
 *
 * @param {string} text             loading state text
 * @param {string} className        additional classes to style outer div
 *
 * @returns {JSX}  the rendered Loading state component
 *
 */
const LoadingState = ({
  text,
  className,
  isBlocking,
  loadingImageHeight,
  loadingImageWidth,
}) => {
  const _className = classnames(styles.root, className, {
    [styles.blocking]: isBlocking,
  });
  const _innerclassName = classnames(styles.inner);
  const _textClassName = classnames(styles.text);

  const theme = useContext(ThemeContext);
  const loadingImageSrc = LOADING_IMAGE_SRC[theme];

  return (
    <div className={_className}>
      <div className={_innerclassName}>
        <img
          src={loadingImageSrc}
          alt="Loading"
          height={loadingImageHeight}
          width={loadingImageWidth}
          className={styles['loading-img']}
        />
        <span data-test-id="loading-state-text" className={_textClassName}>
          {text}
        </span>
      </div>
    </div>
  );
};

LoadingState.propTypes = {
  className: PropTypes.string,
  isBlocking: PropTypes.bool,
  loadingImageHeight: PropTypes.string,
  loadingImageWidth: PropTypes.string,
  text: PropTypes.string,
};

LoadingState.defaultProps = {
  className: '',
  isBlocking: false,
  loadingImageHeight: '24',
  loadingImageWidth: '24',
};

export default LoadingState;
export { LoadingState };
